<div class="block">
    <div class="container">
        <div class="not-found mb-5">
            <div class="not-found__404">
                {{ 'not-found-oops' | t:'Oops! 404' }}
            </div>

            <div class="not-found__content">
                <h1 class="not-found__title">{{ 'page-not-found' | t:'Page Not Found' }}</h1>

                <p class="not-found__text">
                    {{ 'not-found-text' | t:'We can\'t seem to find the page you\'re looking for.' }}<br>
                    {{ 'not-found-try-search' | t:'Try to use the search.' }}
                </p>

                <form class="not-found__search" [formGroup]="form">
                    <input type="text" class="not-found__search-input form-control" [attr.placeholder]="'search-query-placeholder' | t:'Search Query...'"
                        formControlName="query" (keydown.enter)="onEnter()">
                    <button type="submit" class="not-found__search-button btn btn-primary" (click)="onEnter()">{{ 'search' | t:'Search' }}</button>
                </form>

                <p class="not-found__text">
                    {{ 'not-found-go-home-text' | t:'Or go to the home page to start over.' }}
                </p>

                <a class="btn btn-secondary btn-sm" href="index.html">{{ 'go-to-home-page' | t:'Go To Home Page' }}</a>
            </div>
        </div>

        <app-block-products-carousel
            [header]="'🆕 ' + ('not-found-newest-arrivals' | t:'Check Out Our Newest Arrivals – Fresh & Trending!')"
            layout="grid-4"
            [loading]="loading1"
            [products]="columnLatestProducts" 
        ></app-block-products-carousel>

        <app-block-products [header]="'🤖 ' + ('not-found-coolest-gadgets' | t:'From Smart to Stylish – Explore the Coolest Gadgets Now!')" *ngIf="columnLatestProducts2?.length"
            [products]="columnLatestProducts2">
        </app-block-products>

        <app-block-products-carousel
            [header]="'🛍️ ' + ('not-found-high-end-picks' | t:'Exclusive & Exquisite – Shop High-End Picks')"
            layout="horizontal" 
            [rows]="2"
            [loading]="loading3"
            [products]="columnLatestProducts3"
        ></app-block-products-carousel> 
    </div>
</div>
